
import {
  MobileAuthNavigation,
  useMobileViewportDimensions,
  ConfirmDialog,
  usePWAUpdate,
} from '@bd/components'
import { I18nValue, translatePrimeVue } from '@bd/components/i18n'
import { shouldShowAuthNavigation } from '@bd/components/Layout'
import { usePrimeVue } from 'primevue/config'
import {
  defineComponent,
  onMounted,
  watchEffect,
  watch,
  computed,
  ref,
} from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute, useRouter } from 'vue-router'
import { AUTH_NAVIGATION_ROUTES } from './config'
import { useAppStore } from './store'
import * as SW from '@bd/api/firebase-sw'
import { isUserLogged } from '@bd/store-modules/modules/auth/getters-helpers'

export default defineComponent({
  components: {
    MobileAuthNavigation,
    ConfirmDialog,
  },
  setup() {
    const i18n = useI18n()
    const messages = i18n.messages.value as I18nValue
    const route = useRoute()
    const router = useRouter()
    const store = useAppStore()
    const primeVue = usePrimeVue()

    translatePrimeVue(messages, i18n.locale.value, primeVue)

    const showAuthNavigation = shouldShowAuthNavigation(
      route,
      AUTH_NAVIGATION_ROUTES,
    )

    const fetchInitialData = async () => {
      await Promise.all([
        store.dispatch('userProfile/userProfile'),
        store.dispatch('staticData/loadData'),
      ])
      if (isUserLogged(store.state)) {
        const fcmToken = await SW.getFcmToken()
        console.log('📋 User was logged in, FCM token:', fcmToken)
      }
    }

    useMobileViewportDimensions()

    onMounted(() => {
      fetchInitialData()
    })

    watchEffect(() => {
      const bottomNavVisible = ![
        'ClientDetails',
        'DashboardOffer',
        'CalendarEventNew',
        'CalendarEventEdit',
        'CalendarEventDetails',
      ].includes(router.currentRoute.value.name as string)
      store.dispatch('setBottomNavigationVisibility', bottomNavVisible)
    })

    const lastOffer = computed(() => store.state?.purchaseOffers?.purchaseOffer)

    watch(lastOffer, (value) => {
      if (value) {
        store.commit('purchaseOffers/SET_PURCHASE_MESSAGE', value)
      }
    })

    const showPWAUpdateDialog = ref(false)
    const { refreshApp } = usePWAUpdate(() => {
      showPWAUpdateDialog.value = true
    })

    const onUpdateConfirm = () => {
      refreshApp()
      showPWAUpdateDialog.value = false
    }

    return {
      t: i18n.t,
      showAuthNavigation,
      AUTH_NAVIGATION_ROUTES,
      showPWAUpdateDialog,
      onUpdateConfirm,
    }
  },
})
